import { render, staticRenderFns } from "./ApproveFilters.vue?vue&type=template&id=5b5a053f&"
import script from "./ApproveFilters.vue?vue&type=script&lang=js&"
export * from "./ApproveFilters.vue?vue&type=script&lang=js&"
import style0 from "./ApproveFilters.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports